import React, { useState } from "react";
import PropTypes from "prop-types";

// styles
import { BatchProfileRow2Styled } from "./styles";

// components
import ContentComponentRow from "frontend/components/fort/mod/core/Batch/ContentComponents/ContentComponentRow";
import PhotoShootOrIndividual from "frontend/components/fort/mod/core/Batch/ContentComponents/PhotoShootOrIndividual";

const PhotoModBatchProfileRow2 = ({ photoShoot, isEditable }) => {
    /**
     * TODO: Implement Redux Handlers
     * Currently using Faux state to demo updates to Photo Shoot
     * Here is another example of server side implementation: frontend/components/creator-tools/PhotoUploadPage/PhotoUpload/Edit/TitleSection.js
     */
    const [photoShootFauxState, photoShootFauxStateUpdate] = useState(
        photoShoot
    );

    const onSave = async ({ editedText }) => {
        // server side validation async/await
        photoShootFauxStateUpdate({
            ...photoShootFauxState,
            title: editedText,
            titleApproved: true
        });
        const serverError = false;
        if (serverError) {
            // let InlineTextEdit know if there WERE errors.
            return {
                errors: true, // if set to true, remains in {editing mode} and errorMessage is displayed
                errorMessage: "Sorry, something went wrong. Please try again."
            };
        }

        return {
            errors: false, // if set to false, exits {editing mode}
            errorMessage: ""
        };
    };

    const onToggleApprove = () => {
        photoShootFauxStateUpdate({
            ...photoShootFauxState,
            titleApproved: !photoShootFauxState.titleApproved
        });
    };

    return (
        <BatchProfileRow2Styled>
            <ContentComponentRow>
                <PhotoShootOrIndividual
                    photoShoot={photoShootFauxState}
                    onSave={onSave}
                    onToggleApprove={onToggleApprove}
                    isEditable={isEditable.photoShoot}
                />
            </ContentComponentRow>
        </BatchProfileRow2Styled>
    );
};

export default PhotoModBatchProfileRow2;

// prop-types
PhotoModBatchProfileRow2.propTypes = {
    photoShoot: PropTypes.object,
    isEditable: PropTypes.object
};
